import { render, staticRenderFns } from "./ContentFeedBaseView.vue?vue&type=template&id=3e475ddb&scoped=true&"
import script from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedBaseView.vue?vue&type=style&index=0&id=3e475ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e475ddb",
  null
  
)

export default component.exports